export default __webpack_public_path__ + "static/gallery-img4-cd7cff278eb65a9e12c0aee94d750a8a.jpg";